<template>
  <div>
    <doctor-header></doctor-header>
    <div class="header-separator"></div>
    <div style="background-color: rgba(255, 255, 255, .9); margin-top: 200px;">
      <v-container class="site-padding mt-3" id="polishGluacomaSection">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="doctors-container"
        >
          <v-flex xs12 class="text-xs-left">
            <h1 class="doctors-container--header pt-4">polskie forum jaskry</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
      <v-container class="site-padding">
        <v-layout
          align-center
          justify-center
          row
          wrap
          class="doctors-container my-text"
        >
          <v-flex xs12 class="text-xs-left">
            <div>
              <span class="doctors-container--sections"
                >Dziękujemy za udział w Polskim Forum Jaskry. Zapraszamy na
                kolejną edycję w 2021 roku.</span
              >
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-padding">
        <v-layout row wrap class="pb-3">
          <v-flex xs12 md6 class="text-xs-left">
            <div class="banner pt-2">
              <div class="wrapper">
                <div class="text-container px-2 py-2">
                  <router-link
                    :to="{ name: 'ForumProgram' }"
                    class="doctors-container--download"
                  >
                    <v-avatar :size="100" color="rgb(39, 82, 113)">
                      <img
                        src="/static/images/download.svg"
                        alt=""
                        style="height: 50%; border-radius: 0"
                      />
                    </v-avatar>
                    <div class="doctors-container--download-text">
                      <span class="doctors-container--sections"
                        >zobacz szczegółowy PROGRAM</span
                      >
                      <span class="ban2">Polskiego Forum Jaskry 2020</span>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-bottom-padding" id="contactSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-center">
            <img
              id="infarma"
              src="./../assets/images/infarma_badge_2663_Warszawa_2020-03-07.png"
              alt=""
            />
          </v-flex>
        </v-layout>
      </v-container>

      <v-container class="site-bottom-padding" id="contactSection">
        <v-layout row wrap class="doctors-container">
          <v-flex xs12 class="text-xs-left">
            <h1 class="my-header doctors-container--header pt-4">kontakt</h1>
            <div class="sparator-container pt-4">
              <div class="sparator-rectangle"></div>
            </div>
          </v-flex>
        </v-layout>

        <v-layout row wrap class="doctors-container my-text">
          <v-flex xs12 class="text-xs-left">
            <h3 class="doctors-container--sections">
              Jeśli masz pytania, skontaktuj się z nami!
            </h3>
          </v-flex>
        </v-layout>

        <v-form ref="form" v-model="valid" lazy-validation class="pt-3 ">
          <v-container>
            <v-layout
              align-baseline
              justify-center
              row
              wrap
              class="register-form"
            >
              <v-flex xs12 md6 class="text-xs-left px-md-3 px-2">
                <v-text-field
                  class="register-form--noShadow"
                  label="Imię i Nazwisko"
                  solo
                  v-model="form.name"
                  :rules="nameRules"
                ></v-text-field>
                <v-text-field
                  class="register-form--noShadow"
                  label="Telefon"
                  solo
                  v-model="form.phone"
                  mask="###########"
                  :rules="nameRules"
                ></v-text-field>
                <v-text-field
                  class="register-form--noShadow"
                  label="E-mail"
                  solo
                  v-model="form.email"
                  :rules="emailRules"
                ></v-text-field>
                <v-textarea
                  class="register-form--noShadow"
                  label="Wiadomość"
                  solo
                  full-width
                  height="250"
                  rows="13"
                  no-resize
                  v-model="form.message"
                  :rules="nameRules"
                ></v-textarea>
              </v-flex>

              <v-flex xs12 md6 class="text-xs-left px-md-3 px-4">
                <h3 class="patients-container--sections">
                  Sekretariat Polskiego Towarzystwa Okulistycznego
                </h3>
                <div class="pt-3">Samodzielny Publiczny Szpital Kliniczny</div>
                <div class="pt-3">ul. Józefa Sierakowskiego 13</div>
                <div>03-709 Warszawa</div>
                <div class="pt-3">Tel.: 22 511 63 77</div>
                <div>Fax.: 22 511 63 78</div>
                <div class="pt-3">
                  <a
                    href="mailto:pto@pto.com.pl"
                    class="doctors-container--links"
                    >pto@pto.com.pl</a
                  >
                </div>
                <div>
                  <a href="https://pto.com.pl" class="doctors-container--links"
                    >www.pto.com.pl</a
                  >
                </div>
              </v-flex>
              <v-flex
                xs12
                class="text-xs-left px-md-3 px-2"
                id="bulletsSection"
              >
                <div class="two-column">
                  <div class="single-col">
                    <div class="styled-input-container styled-input--rounded">
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted1"
                          v-validate="'required'"
                          data-vv-name="form.accepted1"
                          data-vv-as="zgody"
                          name="accepted"
                          id="checkbox3-example-one"
                        />
                        <label for="checkbox3-example-one">
                          Wyrażam zgodę na przetwarzanie przez LPT Group sp.
                          z&nbsp;o.o. z&nbsp;siedzibą w&nbsp;Łodzi, ul. Gdańska
                          126/128, 90-520 moich danych osobowych zawartych
                          w&nbsp;formularzu rejestracyjnym w&nbsp;celu
                          i&nbsp;zakresie niezbędnym do rejestracji na
                          wydarzenie organizowane przez LPT Grup Sp. z&nbsp;o.o.
                          <br />W związku z&nbsp;wejściem nowego rozporządzenia
                          Unii Europejskiej o&nbsp;ochronie danych osobowych
                          tzw. RODO wyrażam zgodę na przetwarzanie moich danych
                          osobowych zawartych w&nbsp;niniejszym zgłoszeniu dla
                          potrzeb niezbędnych do informowania
                          o&nbsp;Konferencjach i&nbsp;Zjazdach organizowanych
                          przez firmę LPT Group sp. z&nbsp;o.o. z&nbsp;siedzibą
                          w&nbsp;Łodzi, ul. Gdańska 126/128 , 90-520 Łódź
                          (zgodnie z&nbsp;Rozporządzeniem Parlamentu
                          Europejskiego i&nbsp;Rady (UE) 2016/679 - RODO/GDPR
                          z&nbsp;dnia 27 kwietnia 2016 roku, ustawy
                          o&nbsp;ochronie danych osobowych z&nbsp;dnia 10 maja
                          2018 r.).
                        </label>
                        <div class="v-messages__wrapper error--text">
                          <i
                            v-show="errors.has('form.accepted1')"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('form.accepted1')"
                            class="v-messages__message v-messages"
                            >{{ errors.first("form.accepted1") }}</span
                          >
                        </div>
                      </div>
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted2"
                          name="accepted2"
                          id="checkbox3-example-two"
                        />
                        <label for="checkbox3-example-two">
                          Wyrażam zgodę na przesyłanie mi informacji handlowych
                          środkami komunikacji elektronicznej przez: Polskie
                          Towarzystwo Okulistyczne z&nbsp;siedzibą
                          w&nbsp;Warszawie oraz podmioty współpracujące
                          w&nbsp;szczególności z&nbsp;LPT Group sp.&nbsp;z o.o.
                          z&nbsp;siedzibą w&nbsp;Łodzi, zgodnie z&nbsp;ustawą
                          z&nbsp;dnia 18 lipca 2002&nbsp;r. o&nbsp;świadczeniu
                          usług drogą elektroniczną (Dz.&nbsp;U.
                          z&nbsp;2002&nbsp;r. Nr&nbsp;144, poz. 1204
                          z&nbsp;późn. zm.). Wyrażam zgodę na przetwarzanie
                          moich danych osobowych przez Polskie Towarzystwo
                          Okulistyczne z&nbsp;siedzibą w&nbsp;Warszawie
                          w&nbsp;celach marketingowych oraz na przekazywanie mi
                          propozycji zawarcia umowy przy użyciu telefonu zgodnie
                          z&nbsp;Ustawą z&nbsp;dnia 16&nbsp;lipca 2004&nbsp;r.
                          Prawo telekomunikacyjne (tj. Dz.&nbsp;U.
                          z&nbsp;2014&nbsp;r. poz. 243). <br />Oświadczam, że
                          zostałam(em) poinformowana(y) o&nbsp;prawie wglądu do
                          moich danych i&nbsp;dokonywaniu ich zmian.
                        </label>
                      </div>
                      <div class="styled-input-single">
                        <input
                          type="checkbox"
                          v-model="form.accepted3"
                          v-validate="'required'"
                          data-vv-name="form.accepted3"
                          data-vv-as="zgody"
                          name="accepted3"
                          id="checkbox3-example-three"
                        />
                        <label for="checkbox3-example-three">
                          Akceptuję
                          <router-link
                            :to="{ name: 'Regulations' }"
                            class="doctors-container--links"
                            >regulamin.</router-link
                          >
                        </label>
                        <div class="v-messages__wrapper error--text">
                          <i
                            v-show="errors.has('form.accepted3')"
                            class="fa fa-warning"
                          ></i>
                          <span
                            v-show="errors.has('form.accepted3')"
                            class="v-messages__message v-messages"
                            >{{ errors.first("form.accepted3") }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-flex>
            </v-layout>

            <v-layout row @click="submit">
              <v-flex class="xs12 sm6">
                <my-button
                  title="Wyślij wiadomość"
                  text="<span>Wyślij <br>wiadomość</span>"
                  customClass="doctor rect-x1"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-container>
    </div>
    <div class="header-separator" style="height: 50px;"></div>
  </div>
</template>

<script>
import DoctorHeader from "@/components/partials/DoctorHeader";
import MyButton from "@/components/partials/Button";
import moment from "moment";

export default {
  data() {
    return {
      valid: true,
      spacesLeft: undefined,
      form: [
        {
          id: "first_name",
          model: "first_name",
          type: "text",
          name: "first_name"
        },
        { id: "phone", model: "phone", type: "text", name: "phone" },
        { id: "email", model: "email", type: "text", name: "email" },
        { id: "message", model: "message", type: "text", name: "comment" }
      ],
      nameRules: [v => !!v || "Pole jest wymagane"],
      emailRules: [
        v => !!v || "E-mail jest wymagany",
        v =>
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/.test(
            v
          ) || "Zły format"
      ]
      // noSpaces: undefined
    };
  },
  components: {
    DoctorHeader,
    MyButton,
    moment
  },
  mounted() {
    // this.fill();
    this.fetchVerifiedParticipants();
  },
  beforeCreate() {},

  methods: {
    showForum() {
      const dateToCheck = "2020-03-7 20:00:00";
      if (moment().isAfter(dateToCheck)) {
        return true;
      }
    },
    showTransmission() {
      const dateToCheck = "2020-03-7 20:00:00";
      if (moment().isAfter(dateToCheck)) {
        return true;
      }
    },
    showRegOptions() {
      const dateToCheck = "2020-01-15 00:00:00";
      if (moment().isAfter(dateToCheck)) {
        return true;
      }
    },
    showRegForum() {
      const dateToCheck = "2020-01-27 00:00:00";
      if (moment().isAfter(dateToCheck)) {
        return true;
      }
    },

    goRegister() {
      this.$router.push({
        name: "ForumRegister"
      });
    },
    fetchVerifiedParticipants() {
      this.axios({
        method: "GET",
        url: `${process.env.APP_URL}/api/get-forum-participants`
      }).then(result => {
        this.spacesLeft = 70 - result.data.length;
      });
    },
    clearForm() {
      this.form.name = "";
      this.form.phone = "";
      this.form.email = "";
      this.form.message = "";
      this.form.accepted1 = null;
      this.form.accepted2 = null;
      this.form.accepted3 = null;
    },
    submit() {
      if (this.$refs.form.validate()) {
        this.$validator.validateAll().then(result => {
          if (result) {
            this.isDisabled = true;
            const data = {
              form: {
                name: this.form.name,
                email: this.form.email,
                phone: this.form.phone,
                message: this.form.message,
                accepted1: this.form.accepted1,
                accepted2: this.form.accepted2,
                accepted3: this.form.accepted3
              }
            };
            this.axios({
              method: "POST",
              url: `${process.env.APP_URL}/api/send`,
              data
            }).then(
              response => {
                this.isDisabled = false;

                this.clearForm();
                this.$refs.form.reset();

                this.dialog = true;
              },
              response => {
                this.isDisabled = false;
                Object.keys(response.response.data.errors).map(key =>
                  response.response.data.errors[key].map(error =>
                    this.showErrors(error)
                  )
                );
              }
            );
          } else {
            this.scrollToSection("#bulletsSection");
          }
        });
      } else {
        this.scrollToSection("#contactSection");
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.term-container--position {
  align-items: baseline !important;
}
#infarma {
  width: 400px;
  margin: 0 auto;
}
.navigation-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-content: end;
  align-items: end;
}
.navigation-container--position {
  order: 0;
  flex: 0 1 auto;
  align-self: center;
  border-bottom: 5px solid #fff;
}
.banner {
  background-color: transparent;
}

.wrapper {
  width: 100%;
  margin: 0 auto;
}

.banner .text-container {
  font-family: "Fira Sans", sans-serif;
  text-align: left;
  color: #aaa;
  display: flex;
  vertical-align: middle;
  flex-direction: row;
  align-items: center;
}
.banner img {
  float: left;
}

.time-container {
  display: inline-flex;
  width: 100%;
}
.time-container--separator {
  width: 145px;
  padding-right: 5px;
}
.doctors-container--inputs {
  width: 100%;
  padding: 12px 20px;
  margin: 8px 0;
  box-sizing: border-box;
}
.doctors-container--header {
  font-size: 26px;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  color: #a41611;
  text-transform: uppercase;
}
.doctors-container--links {
  color: #a41611;
  font-family: "Fira Sans", sans-serif;
}
.doctors-container--sections {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  text-transform: uppercase;
}
.doctors-container--sections-brown {
  color: #a41611;
}
.doctors-container--sections-slim {
  color: #275271;
  font-family: "Fira Sans", sans-serif;
  font-weight: 900;
  /*text-transform: lowercase;*/
}
.doctors-container--icons {
  background: #275271;
  vertical-align: middle;
  border-radius: 50%;
  width: 120px;
  height: 120px;
  line-height: 120px;
  border: none;
  padding: 20px;
}
.doctors-container--icons-brown {
  background: #a82824;
}
.sparator-container {
  border-bottom: 1px solid black;
  margin-bottom: 10px;
}
.sparator-rectangle {
  width: 115px;
  height: 8px;
  background-color: #275271;
}
.no-padding {
  padding: 0px !important;
  margin-top: 7px;
}
.register-bg {
  position: relative;
}
.register-bg::before {
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  content: "";
  position: fixed;
  opacity: 0.1;
  background-image: url("./../assets/images/register-bg.png");
  background-repeat: repeat;
  background-position: center center;
}
.doctor-header {
  background: #a82824;
  opacity: 0.9;
}
.free-main-header {
  background: #d9e7ee;
  opacity: 0.9;
}
.free-main-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 12px;
}
.main-header--wgw {
  width: 125px;
}
.main-header--pto {
  width: 90px;
}
@media only screen and (min-width: 1024px) and (max-width: 2560px) {
  .main-header--wgw {
    width: 240px;
  }
  .main-header--pto {
    width: 200px;
  }
}
.main-header--free {
  width: 280px;
}
.button-container-blue {
  background: #275271;
  opacity: 0.9;
  cursor: pointer;
}
.button-container-red {
  background: #a82824;
  opacity: 0.9;
  position: relative;
  cursor: pointer;
}
.button-container--register {
  font-family: "Fira Sans", sans-serif;
  font-size: 40px;
  line-height: 40px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.doctor-header--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 50px;
  line-height: 50px;
  font-weight: 900;
  width: 50%;
  color: #fff;
  padding-left: 10px;
  padding-top: 20px;
  text-transform: uppercase;
}
.button-container--text {
  font-family: "Fira Sans", sans-serif;
  font-size: 26px;
  font-weight: 900;
  color: #fff;
  text-decoration: none;
  text-transform: uppercase;
}
.button-container--arrow {
  margin-right: 20px;
}
.free-main-header--margin {
  margin-top: 100px;
}
.button-container--margin {
  margin-bottom: 30px;
}
.button-container--padding {
  padding-top: 50px !important;
  padding-bottom: 50px !important;
}
.button-container--position {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-end;
}
.videoWrapper {
  position: relative;
  width: 95%;
  left: 5%;
  top: 3%;
  padding-bottom: 56.25%; /* 16:9 */
  height: 0;
}
.videoWrapper iframe {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 10px;
}
.button-container--separator {
  position: absolute;
  top: 0;
  width: 115px;
  height: 10px;
  background: #ffffff;
}
.doctors-container--download {
  text-decoration: none;
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: row;
  flex-direction: row;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.doctors-container--download-text {
  display: flex;
  vertical-align: middle;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: flex-start;
  padding-left: 15px;
}

@media only screen and (max-width: 500px) {
  #infarma {
    width: 300px;
  }
}

@media only screen and (max-width: 600px) {
  .button-container--arrow {
    width: 20px;
    margin-right: 5px;
  }
  .button-container--text {
    font-size: 26px;
  }
}
.register-form--noShadow {
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Forum.vue